<template>
	<span class="three-glasses-animation" ref="threeGlasses" />
</template>

<script>
import lottie from 'lottie-web'
import animationData from '@/assets/animation/three-glasses.json'

export default {
	name: 'ThreeGlassAnimation',

	data() {
		return {
			animatedLogo: null
		}
	},

	mounted() {
		this.animatedLogo = lottie.loadAnimation({
			container: this.$refs.threeGlasses,
			renderer: 'svg',
			loop: true,
			autoplay: true,
			animationData
		})
	},

	beforeDestroy() {
		this.animatedLogo && this.animatedLogo.destroy()
	}
}
</script>

<style lang="scss">
.three-glasses-animation {
	display: block;
	width: 100%;
	height: auto;
	margin: 0 auto 20px;

	svg {
		width: 100%;
		height: auto;
	}
}
</style>
